import React, { useEffect, useState } from "react";
import {useSelector, useDispatch} from 'react-redux';
import Button from "@material-ui/core/Button";
import Card from "components/Card/Card.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CardBody from "components/Card/CardBody.js";
import api from "utils/API";
import apiform from "utils/APIForm";
import { getListAllSupplies } from 'actions/getListAction';
import { filterSuppliesByGroup } from 'utils/supplyGroupFilter';
import { Link } from "react-router-dom";
import ViewTitle from "views/Widgets/FichaPersonal/viewTitle";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import { Grid } from "@material-ui/core";
import DetailSelect from "views/Widgets/FichaPersonal/EditFichaPersonal/detailSelect";
import { makeStyles } from "@material-ui/core/styles";
import DetailTextArea from "views/Widgets/FichaPersonal/EditFichaPersonal/detailTextArea";
import Divider from "@material-ui/core/Divider";
import DetailTextDisabled from "views/Widgets/FichaPersonal/EditFichaPersonal/detailTextDisabled";
import ModalSavedDivision from "./ModalSavedDivision";

const GROUP_LABELS = {
  Insumos: "Insumos",
  Medicamentos: "Medicamentos",
  MedicamentosVenta: "Medicamentos Venta",
  Articulos: "Artículos",
  Activos: "Activos",
  Estetica: "Estética",
  Alimentos: "Alimentos",
  Vehiculos: "Vehículos",
  Otro: "Otro",
};

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff"
  }
}));

export default function NewRequest() {
  const [moduleType, setmoduleType] = useState("");
  const [supplies, setSupplies] = useState([]);
  const [group, setGroup] = useState("");
  const [group_final, setGroup_final] = useState("");
  const [sku, setSKU] = useState("");
  const [id_sku, setId_sku] = useState("");
  const [sku_final, setSKU_final] = useState("");
  const [id_sku_final, setId_sku_final] = useState("");
  let list_sku = [];
  let list_sku_final = [];
  const [description, setDescription] = useState("");
  const [description_final, setDescription_final] = useState("");
  const [cantidadFraccionar, setCantidadFraccionar] = useState(1);
  const [cantidad_resultante, setCantidad_resultante] = useState(1);
  const [observaciones, setObservaciones] = useState("");
  const [modalSaved, setModalSaved] = useState(false);
  const [value, setValue] = useState(sku.value);
  const [groupValue, setGroupValue] = useState(group.value);

  const [changes, setChanges] = useState(true);

  const listGroups = useSelector(state => state.currentList.LISTA_TIPO_PRODUCTO);

  const dispatch = useDispatch();
  const dictAllSupplies = useSelector(state => state.currentList.dictAllSupplies);
  const chargeAllSupplies = useSelector(state => state.currentGlobalVar.chargeAllSupplies);

  const suppliesForGroup = filterSuppliesByGroup(Object.values(dictAllSupplies), group.value);
  const supplyList = suppliesForGroup.map(supply => ({ value: supply.SKU, label: supply.SKU }));
  const supplyListFinal = suppliesForGroup
    .filter(supply => supply.SKU !== sku.value)
    .map(supply => ({ value: supply.SKU, label: supply.SKU }));

  useEffect(() => {
    if (changes) {
      initialChargeReception();
    }
  });

  const initialChargeReception = () => {
    setChanges(false);
    const tempArrayURL = window.location.href.split('/');
    setmoduleType(tempArrayURL[tempArrayURL.length-1]);
    if (Object.keys(dictAllSupplies).length === 0) {
      getListAllSupplies(dispatch, chargeAllSupplies);
    }
  };

  useEffect(() => {
    if (group.value && sku.value) {
      const match = suppliesForGroup.find(supply => supply.SKU === sku.value);
      if (match) {
        setDescription(match.descripcion_producto);
        setId_sku(match.id);
      }
    }
    if (group.value && sku_final.value) {
      setGroup_final(GROUP_LABELS[group.value] || group.value);
      const matchFinal = suppliesForGroup.find(supply => supply.SKU === sku_final.value);
      if (matchFinal) {
        setDescription_final(matchFinal.descripcion_producto);
        setId_sku_final(matchFinal.id);
      }
    }
  });


  const handleSKU = sku => {
    setSKU(sku);
  };

  const handleGroup = group => {
    setGroup(group);
  };


  const handleSKUFinal = sku_final => {
    setSKU_final(sku_final);
  };

  function createDivision() {

    const formData = new FormData();

    formData.append("cantidad_fraccionar", cantidadFraccionar);
    formData.append("observaciones", observaciones);
    formData.append("cantidad_resultante", cantidad_resultante);
    formData.append("estado", "Esperar a Ingresos");
    formData.append("id_producto_fraccionar", id_sku);
    formData.append("id_producto_resultante", id_sku_final);
    formData.append("area", "Ingresos");

    apiform
      .post("api/solicitudfraccionamiento/", formData)
      .then(response => {

        setModalSaved(true);
      })

  }

  useEffect(() => {
    if (groupValue != group.value) {
      setGroupValue(group.value);
      setSKU("");
      setDescription("");
      setSKU_final("");
      setGroup_final("");
      setDescription_final("");
    }
    if (value != sku.value) {
      setValue(sku.value);
      setSKU_final("");
      setGroup_final("");
      setDescription_final("");
    }
  });

  return (
    <GridContainer>
      <ViewTitle
        title="SOLICITAR FRACCIONAMIENTO"
        message="En esta sección podrás solicitar un nuevo fraccionamiento."
      />
      <GridItem xs={12} sm={6} md={12}>
        <CardBody className="rounded shadow border border-primary">
          <Breadcrumbs aria-label="breadcrumb">
            <Typography color="textPrimary">Operaciones</Typography>
            <Link color="inherit" to={`/admin/warehouse/task/${moduleType}`}>
              Tareas bodega
            </Link>
            <Link color="inherit" to={`/admin/warehouse/requests/${moduleType}`}>
              Fraccionamiento - Compras
            </Link>
            <Typography color="textPrimary">
              Solicitar fraccionamiento
            </Typography>
          </Breadcrumbs>
        </CardBody>
      </GridItem>
      <GridItem xs={12} sm={6} md={12}>
        <Card>
          <CardBody className="mb-3">
            <Grid container direction="row" justify="center">
              <Grid container item direction="row" xs={8}>
                <Grid item xs={4} align="center" />
                <Grid item xs={4} align="center">
                  <h4 className="font-weight-bold mb-3">SKU a fraccionar</h4>
                </Grid>
                <Grid item xs={4} />
                <DetailSelect
                  label="GRUPO:"
                  value={group}
                  onchange={handleGroup}
                  list={listGroups}
                />
                {group.value ? (
                  <DetailSelect
                    label="SKU:"
                    value={sku}
                    onchange={handleSKU}
                    list={supplyList}
                  />
                ) : (
                  <DetailTextDisabled label="SKU:" value={sku.value} />
                )}



                {/* <DetailSelect
                  label="SKU:"
                  value={sku}
                  onchange={handleSKU}
                  list={list_sku}
                /> */}
                {/* {console.log("sku", sku)} */}
                {/* <DetailTextDisabled label="GRUPO:" value={group} /> */}
                <DetailTextDisabled label="DESCRIPCIÓN:" value={description} />
                <div className="col-md-4 mb-3">
                  <label className="text-dark">CANTIDAD A FRACCIONAR:</label>
                  <input
                    type="number"
                    min="1"
                    className="form-control bg-light font-weight-lighter"
                    style={{ color: "#000000" }}
                    value={cantidadFraccionar}
                    onChange={e => {
                      if (/^[0-9.\b]+$/.test(e.target.value)) {
                        setCantidadFraccionar(parseInt(e.target.value, 10));
                      }
                    }}
                  />
                </div>
                {/* <DetailNumber
                  label="CANTIDAD A FRACCIONAR:"
                  value={cantidadFraccionar}
                  onchange={e => {
                    if (/^[0-9.\b]+$/.test(e.target.value)) {
                      setCantidadFraccionar(e.target.value);
                    }
                  }}
                /> */}
              </Grid>
            </Grid>
            <Divider className="mb-4 mt-3" />
            <Grid container direction="row" justify="center">
              <Grid container item direction="row" xs={8}>
                <Grid item xs={4} align="center" />
                <Grid item xs={4} align="center">
                  <h4 className="font-weight-bold mb-3">SKU resultante</h4>
                </Grid>
                <Grid item xs={4} />
                {group.value && sku.value ? (
                  <DetailSelect
                    label="SKU:"
                    value={sku_final}
                    onchange={handleSKUFinal}
                    list={supplyListFinal}
                  />
                ) : (
                  <DetailTextDisabled label="SKU:" value={sku_final.value} />
                )}
                <DetailTextDisabled label="GRUPO:" value={group_final} />
                <DetailTextDisabled
                  label="DESCRIPCIÓN:"
                  value={description_final}
                />
                <div className="col-md-4 mb-3">
                  <label className="text-dark">
                    CANTIDAD RESULTANTE:
                    {parseInt(cantidad_resultante, 10) <=
                    parseInt(cantidadFraccionar, 10) ? (
                      <span className="text-danger">
                        debe ser mayor a cantidad inicial
                      </span>
                    ) : null}
                  </label>
                  <input
                    type="number"
                    min="1"
                    className="form-control bg-light font-weight-lighter"
                    style={{ color: "#000000" }}
                    value={cantidad_resultante}
                    onChange={e => {
                      if (/^[0-9.\b]+$/.test(e.target.value)) {
                        setCantidad_resultante(parseInt(e.target.value, 10));
                      }
                    }}
                  />
                </div>
              </Grid>
            </Grid>
            <Divider className="mb-4 mt-3" />
            <Grid
              container
              alignContent="center"
              alignItems="center"
              justify="center"
              spacing={2}
            >
              <Grid item xs={8}>
                <DetailTextArea
                  label="OBSERVACIONES:"
                  placeholder="Observaciones"
                  value={observaciones}
                  maxlength="500"
                  onchange={e => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Grid>
            </Grid>
            <Grid
              container
              alignContent="center"
              alignItems="center"
              justify="center"
              spacing={2}
            >
              <Grid item xs={8}>
                {sku ? null : (
                  <span className="text-danger">
                    Debes ingresar un sku
                  </span>
                )}
                {sku_final ? null : (
                  <span className="text-danger">
                    Debes ingresar un sku resultante
                  </span>
                )}
                {observaciones === "" ? (
                  <span className="text-danger">
                    Debes ingresar una observación
                  </span>
                ) : null}
              </Grid>
            </Grid>
            <Grid
              container
              alignContent="center"
              alignItems="center"
              justify="center"
              spacing={2}
            >
              <Grid item>
                {cantidad_resultante > cantidadFraccionar &&
                sku &&
                sku_final &&
                observaciones != "" ? (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={createDivision}
                  >
                    Guardar cambios
                  </Button>
                ) : null}
              </Grid>
              <Grid item>
                <Link to={`/admin/warehouse/requests/${moduleType}`}>
                  <Button variant="contained" color="primary">
                    Cancelar Solicitud
                  </Button>
                </Link>
              </Grid>
            </Grid>
          </CardBody>
        </Card>
      </GridItem>
      {modalSaved && (
        <ModalSavedDivision open={modalSaved} closeModal={() => setModalSaved(false)} moduleType={moduleType} />
      )}
    </GridContainer>
  );
}
